import { useEffect, useState } from "react";

type RepositoryChatEnabledState =
  | { status: "loading"; enabled: false }
  | { status: "ready"; enabled: boolean };

export function useRepositoryChatEnabled(
  probePath = "/user/source-control/chat/conversations",
): RepositoryChatEnabledState {
  const [state, setState] = useState<RepositoryChatEnabledState>({
    enabled: false,
    status: "loading",
  });

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const response = await fetch(probePath, { credentials: "include" });
      if (!cancelled) {
        setState({ enabled: response.ok, status: "ready" });
      }
    };
    void load().catch(() => {
      if (!cancelled) {
        setState({ enabled: false, status: "ready" });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [probePath]);

  return state;
}
